var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col" }, [
      _c(
        "h4",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.trans.title_convert) },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col mt-4" }, [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.checkVoucher.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.voucher.value,
                  expression: "voucher.value",
                },
              ],
              staticClass: "form-control",
              class:
                !_vm.voucher.validated || _vm.errorMessage ? "is-invalid" : "",
              attrs: {
                type: "text",
                id: "exampleInputEmail1",
                "aria-describedby": "emailHelp",
                autocomplete: "off",
                placeholder: _vm.trans.insert_the_voucher,
              },
              domProps: { value: _vm.voucher.value },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.voucher, "value", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.errorMessage) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "btn btn-primary" }, [
            _vm._v(_vm._s(_vm.trans.convert)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }